/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

export const periodo = [
  {
    label: (
      <>
        <p>15</p>
      </>
    ),
    value: '15',
  },
  {
    label: (
      <>
        <p>30</p>
      </>
    ),
    value: '30',
  },
  {
    label: (
      <>
        <p>60</p>
      </>
    ),
    value: '60',
  },
  {
    label: (
      <>
        <p>90</p>
      </>
    ),
    value: '90',
  },
];
